import type { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { em } from 'modules/helpers/style';
import type { Size } from 'types/size';
import type { fontSizeTypes, IText } from '../types';
import Text from './Text';

const StyledText = styled(Text)<{ $strong: LabelProps['strong']; $uppercase: LabelProps['uppercase'] }>`
    font-family: ${({ theme }) => theme.TypographyFamilyPrimary};
    font-weight: ${({ $strong, theme }) => ($strong ? theme.TypographyLabelWeightStrong : theme.TypographyLabelWeightDefault)};
    line-height: 1;

    ${({ $uppercase }) =>
        $uppercase &&
        css`
            text-transform: uppercase;
            letter-spacing: ${em(0.24, 12)};
        `}
`;

type LabelType = 'div' | 'span' | 'a';
export type LabelSize = Extract<Size, 'XS' | 'S' | 'M' | 'L'>;

export interface LabelProps extends HTMLAttributes<HTMLSpanElement> {
    as?: LabelType;
    size: LabelSize;
    strong?: boolean;
    uppercase?: boolean;
}

const overlineSizeMap: Record<LabelSize, fontSizeTypes> = {
    XS: 10,
    S: 12,
    M: 14,
    L: 16
};

export default function Label(props: LabelProps & IText): JSX.Element {
    const { as = 'div', size, strong = false, uppercase, children, ...restProps } = props;

    return (
        <StyledText
            forwardedAs={as}
            size={overlineSizeMap[size]}
            $strong={strong}
            $uppercase={uppercase}
            {...restProps}
        >
            {children}
        </StyledText>
    );
}
